// eslint-disable-next-line
let routes = [
  {
    path: '/home',
    name: 'home.index',
    component: () => import('@/views/Home/Index.vue'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },
  {
    path: '/admin/articles',
    name: 'admin.articles.index',
    component: () => import('@/views/Admin/Articles/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/create',
    name: 'admin.articles.create',
    component: () => import('@/views/Admin/Articles/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/:id',
    name: 'admin.articles.edit',
    component: () => import('@/views/Admin/Articles/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/:article_id/critical-steps',
    name: 'admin.critical-steps.index',
    component: () => import('@/views/Admin/CriticalSteps/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/:article_id/critical-steps/create',
    name: 'admin.critical-steps.create',
    component: () => import('@/views/Admin/CriticalSteps/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/:article_id/critical-steps/:id',
    name: 'admin.critical-steps.edit',
    component: () => import('@/views/Admin/CriticalSteps/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/:article_id/working-steps',
    name: 'admin.working-steps.index',
    component: () => import('@/views/Admin/WorkingSteps/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/:article_id/working-steps/create',
    name: 'admin.working-steps.create',
    component: () => import('@/views/Admin/WorkingSteps/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/articles/:article_id/working-steps/:id',
    name: 'admin.working-steps.edit',
    component: () => import('@/views/Admin/WorkingSteps/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/order-forms',
    name: 'admin.order-forms.index',
    component: () => import('@/views/Admin/OrderForms/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/order-forms/create/:id?',
    name: 'admin.order-forms.create',
    component: () => import('@/views/Admin/OrderForms/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/order-forms/free-dishes/:id',
    name: 'admin.order-forms.free-dishes',
    component: () => import('@/views/Admin/OrderForms/FreeDishes'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/order-forms/planning/:id',
    name: 'admin.order-forms.planning',
    component: () => import('@/views/Admin/OrderForms/Planning'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/order-forms/:id',
    name: 'admin.order-forms.edit',
    component: () => import('@/views/Admin/OrderForms/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/order-forms/:id/orders',
    name: 'admin.orders.index',
    component: () => import('@/views/Admin/Orders/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/order-forms/:id/orders/:order_id',
    name: 'admin.orders.edit',
    component: () => import('@/views/Admin/Orders/Edit'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/companies',
    name: 'admin.companies.index',
    component: () => import('@/views/Admin/Companies/Index'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/companies/create/:id?',
    name: 'admin.companies.create',
    component: () => import('@/views/Admin/Companies/Create'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/companies/:id',
    name: 'admin.companies.edit',
    component: () => import('@/views/Admin/Companies/Edit'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/companies-crm',
    name: 'admin.companies-crm.index',
    component: () => import('@/views/Admin/CompaniesCrm/Index'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/companies-crm/create/:id?',
    name: 'admin.companies-crm.create',
    component: () => import('@/views/Admin/CompaniesCrm/Create'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/companies-crm/:id',
    name: 'admin.companies-crm.edit',
    component: () => import('@/views/Admin/CompaniesCrm/Edit'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/users',
    name: 'admin.users.index',
    component: () => import('@/views/Admin/Users/Index'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/users/google-reviewers',
    name: 'admin.users.reviewers',
    component: () => import('@/views/Admin/Users/Reviewers'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/users/create',
    name: 'admin.users.create',
    component: () => import('@/views/Admin/Users/Create'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/users/:id',
    name: 'admin.users.edit',
    component: () => import('@/views/Admin/Users/Edit'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/journal',
    name: 'admin.journal-records.index',
    component: () => import('@/views/Admin/JournalRecords/Index'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/journal/create',
    name: 'admin.journal-records.create',
    component: () => import('@/views/Admin/JournalRecords/Create'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/journal/:id',
    name: 'admin.journal-records.edit',
    component: () => import('@/views/Admin/JournalRecords/Edit'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/purchase-form',
    name: 'admin.purchase-form',
    component: () => import('@/views/Admin/PurchaseForms/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/orders-and-purchases',
    name: 'admin.orders-and-purchases.index',
    component: () => import('@/views/Admin/OrdersAndPurchases/Index'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/purchases/:id',
    name: 'admin.purchases.edit',
    component: () => import('@/views/Admin/Purchases/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/price-categories',
    name: 'admin.price-categories.index',
    component: () => import('@/views/Admin/PriceCategories/Index'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/price-categories/create',
    name: 'admin.price-categories.create',
    component: () => import('@/views/Admin/PriceCategories/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/price-categories/:id',
    name: 'admin.price-categories.edit',
    component: () => import('@/views/Admin/PriceCategories/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/ingredients',
    name: 'admin.ingredients.index',
    component: () => import('@/views/Admin/Ingredients/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/ingredients/create',
    name: 'admin.ingredients.create',
    component: () => import('@/views/Admin/Ingredients/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/ingredients/:id',
    name: 'admin.ingredients.edit',
    component: () => import('@/views/Admin/Ingredients/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/posts',
    name: 'admin.posts.index',
    component: () => import('@/views/Admin/Posts/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/posts/create',
    name: 'admin.posts.create',
    component: () => import('@/views/Admin/Posts/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/posts/:id',
    name: 'admin.posts.edit',
    component: () => import('@/views/Admin/Posts/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/diets',
    name: 'admin.diets.index',
    component: () => import('@/views/Admin/Diets/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/diets/create',
    name: 'admin.diets.create',
    component: () => import('@/views/Admin/Diets/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/diets/:id',
    name: 'admin.diets.edit',
    component: () => import('@/views/Admin/Diets/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/toppings',
    name: 'admin.toppings.index',
    component: () => import('@/views/Admin/Toppings/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/toppings/create',
    name: 'admin.toppings.create',
    component: () => import('@/views/Admin/Toppings/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/toppings/:id',
    name: 'admin.toppings.edit',
    component: () => import('@/views/Admin/Toppings/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/topping-categories',
    name: 'admin.topping-categories.index',
    component: () => import('@/views/Admin/ToppingCategories/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/topping-categories/create',
    name: 'admin.topping-categories.create',
    component: () => import('@/views/Admin/ToppingCategories/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/topping-categories/:id',
    name: 'admin.topping-categories.edit',
    component: () => import('@/views/Admin/ToppingCategories/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/deadlines',
    name: 'admin.deadlines.index',
    component: () => import('@/views/Admin/Deadlines/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/deadlines/create',
    name: 'admin.deadlines.create',
    component: () => import('@/views/Admin/Deadlines/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/deadlines/:id',
    name: 'admin.deadlines.edit',
    component: () => import('@/views/Admin/Deadlines/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/postal-codes',
    name: 'admin.postal_codes.index',
    component: () => import('@/views/Admin/PostalCodes/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/postal-codes/create',
    name: 'admin.postal_codes.create',
    component: () => import('@/views/Admin/PostalCodes/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/postal-codes/:id',
    name: 'admin.postal_codes.edit',
    component: () => import('@/views/Admin/PostalCodes/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/company-types',
    name: 'admin.company-types.index',
    component: () => import('@/views/Admin/CompanyTypes/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/company-types/create',
    name: 'admin.company-types.create',
    component: () => import('@/views/Admin/CompanyTypes/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/company-types/:id',
    name: 'admin.company-types.edit',
    component: () => import('@/views/Admin/CompanyTypes/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/journal-types',
    name: 'admin.journal-types.index',
    component: () => import('@/views/Admin/JournalTypes/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/journal-types/create',
    name: 'admin.journal-types.create',
    component: () => import('@/views/Admin/JournalTypes/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/journal-types/:id',
    name: 'admin.journal-types.edit',
    component: () => import('@/views/Admin/JournalTypes/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/delivery-areas',
    name: 'admin.delivery_areas.index',
    component: () => import('@/views/Admin/DeliveryAreas/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/delivery-areas/create',
    name: 'admin.delivery_areas.create',
    component: () => import('@/views/Admin/DeliveryAreas/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/delivery-areas/:id',
    name: 'admin.delivery_areas.edit',
    component: () => import('@/views/Admin/DeliveryAreas/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/sales-per-week',
    name: 'admin.data.sales_per_week',
    component: () => import('@/views/Admin/Data/SalesPerWeek'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/sales-per-week-price',
    name: 'admin.data.sales_per_week_price',
    component: () => import('@/views/Admin/Data/SalesPerWeekPrice'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/sales-per-form',
    name: 'admin.data.sales_per_form',
    component: () => import('@/views/Admin/Data/SalesPerForm'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/data/sales-per-form-price',
    name: 'admin.data.sales_per_form_price',
    component: () => import('@/views/Admin/Data/SalesPerFormPrice'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/data/ratings',
    name: 'admin.data.ratings',
    component: () => import('@/views/Admin/Data/Ratings'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/ratings-for-article/:id',
    name: 'admin.data.ratings_for_article',
    component: () => import('@/views/Admin/Data/RatingsForArticle'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/donations',
    name: 'admin.data.donations',
    component: () => import('@/views/Admin/Donations/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/donations-per-article',
    name: 'admin.data.donations_per_article',
    component: () => import('@/views/Admin/Data/DonationsPerArticle'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/promocodes',
    name: 'admin.data.promocodes.index',
    component: () => import('@/views/Admin/Promocodes/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/promocodes/create',
    name: 'admin.data.promocodes.create',
    component: () => import('@/views/Admin/Promocodes/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/promocodes/:id',
    name: 'admin.data.promocodes.edit',
    component: () => import('@/views/Admin/Promocodes/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/discount-codes',
    name: 'admin.data.discount-codes.index',
    component: () => import('@/views/Admin/DiscountCodes/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/discount-codes/create',
    name: 'admin.data.discount-codes.create',
    component: () => import('@/views/Admin/DiscountCodes/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/discount-codes/:id',
    name: 'admin.data.discount-codes.edit',
    component: () => import('@/views/Admin/DiscountCodes/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/discount-codes-distribute',
    name: 'admin.data.discount-codes-distribute.index',
    component: () => import('@/views/Admin/DiscountCodes/Distribute'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/articles-nutrition',
    name: 'admin.data.articles_nutrition',
    component: () => import('@/views/Admin/Data/ArticlesNutrition'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/company-price-category-prices',
    name: 'admin.data.company_price_category_prices',
    component: () => import('@/views/Admin/Data/CompanyPriceCategoryPrices'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/net-promoter-score',
    name: 'admin.data.net_promoter_score',
    component: () => import('@/views/Admin/Data/NetPromoterScores'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/data/lifetime-sales',
    name: 'admin.data.lifetime_sales',
    component: () => import('@/views/Admin/Data/CustomerLifetimeSales'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/invoices',
    name: 'admin.tools.invoices',
    component: () => import('@/views/Admin/Tools/Invoices'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/sponsoring-invoices',
    name: 'admin.tools.sponsoring-invoices',
    component: () => import('@/views/Admin/Tools/SponsoringInvoices'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/invoices-with-status',
    name: 'admin.tools.invoices-status',
    component: () => import('@/views/Admin/Invoices'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/payments',
    name: 'admin.tools.payments',
    component: () => import('@/views/Admin/Tools/Payments'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/totals',
    name: 'admin.tools.totals',
    component: () => import('@/views/Admin/Tools/Totals'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/kpi',
    name: 'admin.tools.kpi',
    component: () => import('@/views/Admin/Tools/Kpi'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/discount-codes',
    name: 'admin.tools.discount-codes',
    component: () => import('@/views/Admin/Tools/DiscountCodes'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/tour-plans',
    name: 'admin.tour-plans.index',
    component: () => import('@/views/Admin/TourPlans/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/tour-plans/create',
    name: 'admin.tour-plans.create',
    component: () => import('@/views/Admin/TourPlans/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tools/tour-plans/:id',
    name: 'admin.tour-plans.edit',
    component: () => import('@/views/Admin/TourPlans/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/tour-plans/:id/overview',
    name: 'admin.tour-plans.overview',
    component: () => import('@/views/Admin/TourPlans/Overview'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/work-times',
    name: 'admin.work-times.index',
    component: () => import('@/views/Admin/WorkTimes/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/work-times/create',
    name: 'admin.work-times.create',
    component: () => import('@/views/Admin/WorkTimes/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/work-times/:id',
    name: 'admin.work-times.edit',
    component: () => import('@/views/Admin/WorkTimes/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/work-times-my',
    name: 'work-times-my.index',
    component: () => import('@/views/WorkTimesMy/Index'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/work-times-my/create',
    name: 'work-times-my.create',
    component: () => import('@/views/WorkTimesMy/Create'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/work-times-my/:id',
    name: 'work-times-my.edit',
    component: () => import('@/views/WorkTimesMy/Edit'),
    meta: {
      perimeter: 'VertriebPerimeter',
    },
  },

  {
    path: '/admin/trip-reports',
    name: 'admin.trip-reports.index',
    component: () => import('@/views/Admin/TripReports/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/trip-reports/create',
    name: 'admin.trip-reports.create',
    component: () => import('@/views/Admin/TripReports/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/trip-reports/:id',
    name: 'admin.trip-reports.edit',
    component: () => import('@/views/Admin/TripReports/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  /**
   * Draft emails
   */
  {
    path: '/admin/draft-emails',
    name: 'admin.draftEmails.index',
    component: () => import('@/views/Admin/DraftEmails/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/draft-emails/create',
    name: 'admin.draftEmails.create',
    component: () => import('@/views/Admin/DraftEmails/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/draft-emails/:id',
    name: 'admin.draftEmails.edit',
    component: () => import('@/views/Admin/DraftEmails/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  /**
   * Navbar links
   */
  {
    path: '/admin/navbar-links',
    name: 'admin.navbar-links.index',
    component: () => import('@/views/Admin/NavbarLinks/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/navbar-links/create',
    name: 'admin.navbar-links.create',
    component: () => import('@/views/Admin/NavbarLinks/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/navbar-links/:id',
    name: 'admin.navbar-links.edit',
    component: () => import('@/views/Admin/NavbarLinks/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/awards',
    name: 'admin.awards.index',
    component: () => import('@/views/Admin/Awards/Index'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/awards/create',
    name: 'admin.awards.create',
    component: () => import('@/views/Admin/Awards/Create'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },

  {
    path: '/admin/awards/:id',
    name: 'admin.awards.edit',
    component: () => import('@/views/Admin/Awards/Edit'),
    meta: {
      perimeter: 'AdminPerimeter',
    },
  },
];

// [
//   { entity: 'PriceCategory', path: 'price-categories', name: 'Preiskategorie', breadcrumb: 'Preiskategorien' },
// ].forEach((el) => {
//   const meta = {
//     perimeter: 'AdminPerimeter',
//     entity: el.entity,
//     path: el.path,
//     name: el.name,
//     breadcrumb: el.breadcrumb,
//     fields: el.fields || [],
//   };
//   routes = routes.concat(
//     [
//       {
//         path: `/admin/${el.path}`,
//         name: `admin.${el.path}.index`,
//         component: () => import('@/views/Admin/Universal/Index'),
//         meta,
//       },
//
//       {
//         path: `/admin/${el.path}/create`,
//         name: `admin.${el.path}.create`,
//         component: () => import('@/views/Admin/Universal/Create'),
//         meta,
//       },
//
//       {
//         path: `/admin/${el.path}/:id`,
//         name: `admin.${el.path}.edit`,
//         component: () => import('@/views/Admin/Universal/Edit'),
//         meta,
//       },
//     ],
//   );
// });

export default routes;



// WEBPACK FOOTER //
// ./src/routes/admin.js